import React, { CSSProperties } from "react";

interface IProps {
  title: string;
}

const Group: React.FC<IProps> = React.memo((props) => {
  const { title, children } = props;

  return (
    <div style={container}>
      <div style={titleStyles}>{title}</div>
      <div>{children}</div>
    </div>
  );
});

const container: CSSProperties = {};

const titleStyles: CSSProperties = {
  paddingTop: 12,
  paddingBottom: 12,
  paddingLeft: 16,
  paddingRight: 16,
  fontSize: Math.ceil(14 * 1.27),
  fontWeight: 600,
};

export default Group;
